export enum Phases {
	Unscheduled = "PHA_UNSCHEDULED",
	Screening = "PHA_SCREENING",
	Treatment = "PHA_TREATMENT",
	EarlyTermination = "PHA_EARLY_TERMINATION",
	FollowUp = "PHA_FOLLOW_UP",
}